module.exports = __webpack_public_path__ + "img/bg_pros.f487ccc6.png";